import { RegionCargando, Skeleton, type ColumnaSkeleton } from "@/components/ui";

/** Columnas de la tabla de eventos (expandir, evento, ocurrió, intentos, estado, próximo, error, acción). */
export const COLUMNAS_EVENTOS_SKELETON: ColumnaSkeleton[] = [
  { w: 0.4 },
  { w: 2.2 },
  { w: 1.4 },
  { w: 0.8 },
  { w: 1 },
  { w: 1.4 },
  { w: 2.4 },
  { w: 1.1, align: "right" },
];

/** Tarjetas de módulo en carga (9 = módulos con outbox hoy) · misma rejilla y forma (nombre + 2 badges) que las reales. */
export function ModulosEventosSkeleton({ n = 9 }: { n?: number }) {
  return (
    <RegionCargando etiqueta="Cargando módulos…" className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5">
      {Array.from({ length: n }, (_, i) => (
        <div key={i} className="rounded-lg border border-border p-3" aria-hidden="true">
          <Skeleton height={14} width={i % 2 === 0 ? "70%" : "55%"} />
          <div className="mt-2 flex gap-1.5">
            <Skeleton height={16} width={70} className="rounded-full" />
            <Skeleton height={16} width={84} className="rounded-full" />
          </div>
        </div>
      ))}
    </RegionCargando>
  );
}
